import { useNextStep } from 'nextstepjs'
import { useAppTourSteps } from 'src/component/app-tour/use-app-tour-steps'
import { useMediaQuery } from './use-media-query'
import { useEffect, useRef, type Dispatch, type SetStateAction } from 'react'

const MOBILE_NAV_MEDIA_QUERY = '(max-width: 991.98px)'

/**
 * On narrow viewports, expands the collapsed navbar while the app tour is on
 * the Workouts step so the spotlight target is visible. Collapses again when
 * leaving that step or ending the tour, but only if this hook had expanded the
 * menu (avoids closing a menu the user opened themselves).
 */
export function useExpandNavbarForAppTourWorkoutsStep(setNavExpanded: Dispatch<SetStateAction<boolean>>): void {
  const isMobileNavLayout = useMediaQuery(MOBILE_NAV_MEDIA_QUERY)
  const { currentStep, isNextStepVisible } = useNextStep()
  const { navWorkoutsStepIndex } = useAppTourSteps()
  const expandedByThisTourStepRef = useRef(false)

  useEffect(() => {
    if (!isMobileNavLayout) {
      return
    }

    const shouldExpandForTour = isNextStepVisible && currentStep === navWorkoutsStepIndex

    if (shouldExpandForTour) {
      expandedByThisTourStepRef.current = true
      setNavExpanded(true)
      return
    }

    if (expandedByThisTourStepRef.current) {
      expandedByThisTourStepRef.current = false
      setNavExpanded(false)
    }
  }, [isMobileNavLayout, isNextStepVisible, currentStep, navWorkoutsStepIndex, setNavExpanded])
}
